import { render, staticRenderFns } from "./CrmContacts.vue?vue&type=template&id=3d8c18ee&scoped=true"
import script from "./CrmContacts.vue?vue&type=script&lang=js"
export * from "./CrmContacts.vue?vue&type=script&lang=js"
import style0 from "./CrmContacts.vue?vue&type=style&index=0&id=3d8c18ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8c18ee",
  null
  
)

export default component.exports